import { useEffect } from 'react';
import MainPageLayout from 'layouts/MainPageLayout';
import { FormattedMessage } from 'react-intl';
import { useSelectedLinkContext } from 'contexts';
import { useQuery } from '@apollo/client';
import {
  GET_PARTNER_ACCOUNTS_WITH_FAMILY_PORTAL_QUERY,
  GetPartnerAccountsWithFamilyPortalOutput,
} from 'graphql/partnerdocuments/PartnerDocumentsQueries';
import { navigateToSelectedChannelRoute } from 'utils/history';
import Route from 'routes/Routes';
import { Grid } from '@mui/material';
import { PartnerAccount } from 'types';
import PartnerListItem from './Partner/PartnerListItem';
import useStyles from './PartnerList.styles';

type PartnerListPureProps = {
  partnerAccounts: PartnerAccount[];
};

const PartnerListPure = ({
  partnerAccounts,
}: PartnerListPureProps): JSX.Element => {
  const classes = useStyles();

  return (
    <MainPageLayout title={<FormattedMessage id="partner.description" />}>
      <Grid className={classes.container} container>
        {partnerAccounts.map((partnerAccount) => (
          <Grid className={classes.item} item key={partnerAccount.id} md={4}>
            <PartnerListItem partnerAccount={partnerAccount} />
          </Grid>
        ))}
      </Grid>
    </MainPageLayout>
  );
};

const PartnerList = (): JSX.Element | null => {
  const { selectedLink } = useSelectedLinkContext();
  const { data, loading } =
    useQuery<GetPartnerAccountsWithFamilyPortalOutput>(
      GET_PARTNER_ACCOUNTS_WITH_FAMILY_PORTAL_QUERY,
      {
        variables: {
          channel: selectedLink?.channelKey,
        },
      },
    );

  const partnerAccounts =
    data?.getPartnerAccountsWithFamilyPortal?.partnerAccounts;

  useEffect(() => {
    if (!loading && !partnerAccounts?.length) {
      navigateToSelectedChannelRoute(selectedLink, Route.HELP);
    }
  }, [loading, partnerAccounts, selectedLink]);

  if (loading || !partnerAccounts?.length) {
    return null;
  }

  return <PartnerListPure partnerAccounts={partnerAccounts} />;
};

export default PartnerList;
